import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import bugContext from "@/lib/bugContext";

// Initialize global bug context tracker (console errors, API failures, clicks)
bugContext.init();

// Prevent benign ResizeObserver "loop completed" errors at the source.
// Wrapping the callback in rAF batches notifications and avoids the browser
// throwing the error that React's dev overlay then catches.
const _RO = window.ResizeObserver;
window.ResizeObserver = class extends _RO {
  constructor(cb) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => { cb(entries, observer); });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
